var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDinersClub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "48px",
    viewBox: "0 0 72 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/Tender_Dinersclub") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tender_Dinersclub",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#E6E6E6",
    x: 0,
    y: 0,
    width: 72,
    height: 48,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(17.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-5.32907052e-15,17.1045501 C-5.32907052e-15,7.65792075 7.65792075,3.55271368e-15 17.1041678,3.55271368e-15 C26.5507972,3.55271368e-15 34.2087179,7.65792075 34.2087179,17.1045501 C34.2087179,26.5511795 26.5507972,34.2094825 17.1041678,34.2094825 C7.65792075,34.2094825 -5.32907052e-15,26.5511795 -5.32907052e-15,17.1045501",
    id: "Fill-42-Copy",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1904149,17.6852405 C28.1835338,13.305026 25.4456131,9.56934303 21.5875991,8.08990247 L21.5875991,27.2798139 C25.4456131,25.7984619 28.1835338,22.0662195 28.1904149,17.6852405 Z M14.2278601,27.2759911 L14.2278601,8.09181389 C10.3732867,9.57584187 7.6395711,13.3061729 7.62924942,17.6852405 C7.6395711,22.0631612 10.3732867,25.7931099 14.2278601,27.2759911 Z M17.909641,1.46529641 C8.95195338,1.46873697 1.69466667,8.72755282 1.69313753,17.6852405 C1.69466667,26.6417813 8.95195338,33.8994503 17.909641,33.9009794 C26.8673287,33.8994503 34.1261445,26.6417813 34.1284382,17.6852405 C34.1261445,8.72755282 26.8673287,1.46873697 17.909641,1.46529641 Z M17.8698834,35.4316461 C8.0677296,35.4782848 1.42108547e-14,27.5370913 1.42108547e-14,17.8702661 C1.42108547e-14,7.30545492 8.0677296,-0.00191104684 17.8698834,3.75072219e-07 L22.4634126,3.75072219e-07 C32.1497343,-0.00191104684 40.9900606,7.30201436 40.9900606,17.8702661 C40.9900606,27.5336507 32.1497343,35.4316461 22.4634126,35.4316461 L17.8698834,35.4316461 Z",
    id: "Fill-43-Copy",
    fill: "#48A0DC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDinersClub);
export default __webpack_public_path__ + "assets/media/dinersClub.3e2946f67da62291e7a8a05b328780f2.svg";
export { ForwardRef as ReactComponent };